module.exports = __webpack_public_path__ + "static/media/star-blue.af4d6c13.svg";